import { Switch, Form, Input, Select } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useTranslation } from "react-i18next"


const TextForm = ({ formValues, form, showPreviousDataFetch = false }) => {
    const { t } = useTranslation();

    return (
        <>
            <Form.Item name="label" label={t("Label")}>
                <Input placeholder={t("Enter label")} />
            </Form.Item>

            <Form.Item name="placeholder" label={t("Placeholder")}>
                <Input placeholder={t("Enter placeholder")} />
            </Form.Item>

            <Form.Item name="tooltip" label={t("Tooltip")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            {
                formValues && formValues.tooltip &&
                <Form.Item label={t("Help Text")} name="helpText">
                    <TextArea rows={2} placeholder={t("Enter help text")} />
                </Form.Item>
            }

            <Form.Item name="mandatory" label={t("Mandatory")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="readOnly" label={t("Read Only")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="hideInitially" label={t("Hide Initially")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
             <Form.Item name="alphanumeric" label={t("Alphanumeric Only")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="mapProfile" label={t("Map Profile")} className="horizontal-form-item">
                <Switch
                    size="small"
                    onChange={(checked) => {
                        if (!checked) {
                            form.setFieldsValue({ profileField: undefined })
                        }
                    }}
                />
            </Form.Item>
            {
                formValues && formValues.mapProfile &&
                <Form.Item name="profileField" label={t("Select Profile Field")}>
                    <Select placeholder={t("Select profile field")}>
                        <Select.Option value="name">{t("Name")}</Select.Option>
                        <Select.Option value="email">{t("Email")}</Select.Option>
                        <Select.Option value="employeeId">{t("Employee ID")}</Select.Option>
                    </Select>
                </Form.Item>
            }
            {
                showPreviousDataFetch &&
                <Form.Item name="enablePreviousDataFetch" label={t("Enable Previous Data Fetch")} className="horizontal-form-item">
                    <Switch size="small" />
                </Form.Item>
            }
            <Form.Item
                name="minNumber"
                label={t("Min Characters")}
                rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (value === undefined || value === null || String(value).trim() === "") {
                                return Promise.resolve();
                            }
                            const num = Number(value);
                            if (Number.isNaN(num) || !Number.isInteger(num)) {
                                return Promise.reject(new Error(t("Enter a valid number")));
                            }
                            if (num < 0) {
                                return Promise.reject(new Error(t("No negative numbers allowed")));
                            }
                            const max = getFieldValue("maxNumber");
                            if (max !== undefined && String(max).trim() !== "" && Number.isFinite(Number(max)) && num >= Number(max)) {
                                return Promise.reject(new Error(t("Min Characters must be less than Max Characters")));
                            }
                            return Promise.resolve();
                        },
                    }),
                ]}
            >
                <Input
                    placeholder={t("Enter min number of characters")}
                    type="number"
                    min={0}
                    // style={{ width: "200px" }}
                />
            </Form.Item>

            <Form.Item
                name="maxNumber"
                label={t("Max Characters")}
                rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (value === undefined || value === null || String(value).trim() === "") {
                                return Promise.resolve();
                            }
                            const num = Number(value);
                            if (Number.isNaN(num) || !Number.isInteger(num)) {
                                return Promise.reject(new Error(t("Enter a valid number")));
                            }
                            if (num < 0) {
                                return Promise.reject(new Error(t("No negative numbers allowed")));
                            }
                            const min = getFieldValue("minNumber");
                            if (min !== undefined && String(min).trim() !== "" && Number.isFinite(Number(min)) && num <= Number(min)) {
                                return Promise.reject(new Error(t("Max Characters must be greater than Min Characters")));
                            }
                            return Promise.resolve();
                        },
                    }),
                ]}
            >
                <Input
                    placeholder={t("Enter max number of characters")}
                    type="number"
                    min={0}
                    // style={{ width: "200px" }}
                />
            </Form.Item>
        </>
    )
}

export default TextForm